/**
 * FloorPlanDemo — the real explainer video for the Floor Plan Tool.
 * Wrapped in branded browser-chrome for consistency with the rest of the Help page.
 * The MP4 is web-optimised (~1.6 MB, H.264 + AAC + faststart) and uses
 * `preload="metadata"` so the poster loads instantly but the video only
 * downloads when the user hits play.
 */
export const FloorPlanDemo = () => {
  return (
    <div
      className="fp-demo rounded-lg border border-border/60 bg-card overflow-hidden"
      data-testid="floor-plan-demo"
    >
      {/* Faux toolbar */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-border/40 bg-background/40 text-[10px] uppercase tracking-wider text-muted-foreground">
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-red-500/60" />
          <span className="h-2 w-2 rounded-full bg-amber-500/60" />
          <span className="h-2 w-2 rounded-full bg-green-500/60" />
          <span className="ml-2">Floor Plan Tool · Walkthrough</span>
        </div>
        <span className="hidden sm:inline">Live product recording</span>
      </div>

      <div className="relative aspect-video bg-background">
        <video
          className="absolute inset-0 h-full w-full"
          controls
          preload="metadata"
          playsInline
          poster="/videos/floor-plan-how-to-poster.jpg"
          data-testid="floor-plan-demo-video"
        >
          <source src="/videos/floor-plan-how-to.mp4" type="video/mp4" />
          Your browser does not support HTML5 video.{" "}
          <a
            href="/videos/floor-plan-how-to.mp4"
            className="text-cyan-400 underline"
          >
            Download the walkthrough
          </a>
          .
        </video>
      </div>
    </div>
  );
};

export default FloorPlanDemo;
